import React, { useState } from 'react';
import { colorMapping } from './colors';

const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const Timeline = ({ events, onFilter, getWeekOfMonth }) => {
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [selectedWeek, setSelectedWeek] = useState(null);

  // Aggregate events by type to apply colors
  const aggregateEventsByType = events.reduce((acc, event) => {
    const month = new Date(event.date).getMonth();
    const week = getWeekOfMonth(new Date(event.date));
    const key = month * 4 + week - 1; // Calculate the index based on month and week
    if (!acc[key]) {
      acc[key] = {};
    }
    acc[key][event.type] = true; // Mark the type present for this week
    return acc;
  }, {});

  const handleBoxClick = (month, week) => {
    // Check if the box is already selected
    if (selectedMonth === month && selectedWeek === week) {
      setSelectedMonth(null); // Deselect if already selected
      setSelectedWeek(null);
      onFilter(null, null); // Reset filter
    } else {
      setSelectedMonth(month);
      setSelectedWeek(week);
      onFilter(month, week); // Apply filter
    }
  };

  return (
    <div className="flex flex-wrap mb-2 text-gray-600 dark:text-gray-300">
      {months.map((month, i) => (
        <div key={i} className="flex flex-col items-center">
          <div className="text-xs mb-1">{month}</div>
          <div className="flex">
            {Array.from({ length: 4 }, (_, k) => {
              const index = i * 4 + k;
              const typesPresent = aggregateEventsByType[index];
              let colorClass = 'bg-gray-300 dark:bg-stone-600';
              if (typesPresent) {
                const types = Object.keys(typesPresent);
                colorClass = colorMapping[types[0]] || 'bg-gray-300 dark:bg-stone-600';
              }
              const isSelected = selectedMonth === i && selectedWeek === k + 1;
              const borderColor = isSelected ? 'border-blue-500 dark:border-indigo-500' : 'border dark:border-stone-500';

              return (
                <div key={k}
                     className={`w-4 h-4 cursor-pointer ${borderColor} ${colorClass} ${isSelected ? 'border-2' : 'border'}`}
                     onClick={() => handleBoxClick(i, k + 1)}>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Timeline;
